import Vue from 'vue'
import axios from 'axios'
import {vuexOidcCreateStoreModule} from 'vuex-oidc'
import {oidcSettings} from '../config/oidc'
import pyChar from 'js-pinyin'
import store from '..'
import qs from 'qs'
// import testApp from '../../../static/test-app.js'

const state = {
    searchValue:'',//servercenter 搜索
    loadingDataStart: false,
    targetMessage: '',
    isCanFresh: true,
    apiMap: {
        'todo': {
            url: 'me/tasks/todo',
            query: ''
        },
        'doing': {
            url: 'me/processes/doing',
            query: {
                limit: 10,
                start: 0,
                keyword: '',
                sep: null
            },
        },
        'done': {
            url: 'me/processes/done',
            query: {
                limit: 10,
                start: 0,
                keyword: '',
                sep: null
            }
        },
        'flow_cc': {
            url: 'me/processes/cc',
            query: {
                limit: 10,
                start: 0,
                unread: true,
                keyword: '',
                sep: null
            },
        },
        'weituo': {
            url: 'me/tasks/todo?entrust=true',
            query: ''
        }
    },
    dataSource: {
        'todo': [],
        'doing': [],
        'done': [],
        'flow_cc': [],
        'weituo': []
    },
    dataLength: {
        'todo': 0,
        'done': 0,
        'doing': 0,
        'flow_cc': 0,
        'cc': 0, // 未读的抄送数量
        'medoing': 0, // 进行中属于自己那方的数量
        'weituo': 0
    },
    accumulate: 0,  // 累计服务人数
    todayViews: 0,  // 今日访客
    allViews: 0,  // 所有访客
    appList: [],
    statsRes: [],
    statsTimeBetweenRes: [],
    recommends: [],
    userId: '',
    tags: [],
    otherTags: [],
    department: [],
    specialTags:[],
    seconedTags: [],
    tagApps: [],
    positionsMes: [],
    wtThings: {
        'entrustees': [],
        'entrusters': [],
        'total': 0
    },
    process_pass: [],
    favorites: [],
    favoriteApps: [],
    zm: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    //由tagApps拿到的字母
    zimu: [],
    highlights: [],
    todoWeiTuo: [],
    appQuery: {
        seq: '',
        tag: '',
        department: '',
        other: '',
        zimu: '',
        secTag: ''
    },
    userInfos: {}
}

Vue.filter('noNum', function (sortTag) {    // msg 为固定的参数 即是你需要过滤的数据
    let sortTagList = [];
    sortTag.split(',').forEach(item => {
        sortTagList.push(deleteNum(item));
    })
    function deleteNum(item){
        let tags = item && item.split("-");
        if (tags && parseInt(tags[0]) >= 0) {
            return item.replace(tags[0] + '-', '');
        } else {
            return item;
        }
    }
    return sortTagList && sortTagList.join(',');
});

const getters = {
    getAuth: () => store.state.oidcStore,
    getEmail: () => store.state.oidcStore.user.email,
    getUserInfo: () => store.state.userInfos,
    getId: () => store.state.userInfos.id,
    getAccumulate: state => state.accumulate,
    getTodayViews: state => state.todayViews,
    getAllViews: state => state.allViews,
    getAppList: state => state.appList,
    getRecommends: state => state.recommends,
    getTags: state => state.tags,
    getZimu: state => state.zimu,
    getOtherTags: state => state.otherTags,
    getDep: state => state.department,
    getSpeTags: state => state.specialTags,
    getSeconedTags: state => state.seconedTags,
    getTagApps: state => state.tagApps,
    getWeiTuo: state => state.wtThings,
    getHighLights: state => state.highlights,
    getFavorites: state => state.favorites,
    getFavoriteApps: state => state.favoriteApps,
    getProcess: state => state.process_pass,
    getState: state => state,
    getDataSourceMap: state => state.apiMap,
    getDataSource: state => state.dataSource,
    getDataLength: state => state.dataLength,
    getPositions: state => state.positionsMes,
    getStatsRes: state => state.statsRes,
    getStatsTimeBetweenRes: state => state.statsTimeBetweenRes
}
const actions = {
    // 登录状态查询所有应用
    async fetchAppList({commit, state, dispatch}, filterApp) {
        commit('loadingData', true);
        await axios.get(`${window.commonApi.INFOPLUS_URL}/me/apps`).then(res => {
            // res = testApp;
            if (res.data.errno == 0) {
                var str = /^[A-Za-z]*$/;
                let appList = res.data.entities.map(item => {
                    return {
                        ...item,
                        shouzimu: str.test(pyChar.getFullChars(item.name).toUpperCase().slice(0, 1)) ? pyChar.getFullChars(item.name).toUpperCase().slice(0, 1) : pyChar.getFullChars(item.name).toUpperCase().slice(1, 1)
                    }
                });
                // 没有二级second-tag时 卡片title 显示为一级tags(不显示‘其他’)
                appList = appList.map(m=>{
                   if(m.tags.indexOf('$tag$')>-1){
                       let arrM=m.tags.split(',')
                       let s=''

                       if(arrM.length){
                           arrM = arrM.filter(k=>{
                               return k.startsWith('$tag$')
                           })
                           s=arrM[0].split("$tag$")[1]
                       }
                       if(m.tags.indexOf('$second-tag$')==-1){
                           m.tags = m.tags+`,$second-tag$${s}:${s}`
                       }
                   }
                    return m
                })

                if (filterApp) {
                    state.appList = filterApp(appList);
                } else {
                    state.appList = appList;
                }
                dispatch('getStatus', state.appList);
                dispatch('getTimeBetweenStatus', state.appList);
                dispatch('metodoLength');
                dispatch('favoriteGet');
                commit('updateAppList');
                commit('updateAppAll');
            }
        }).catch(error => {
            commit('loadingData', false);
            console.log(error);
        });
    },
    // 未登录状态查询所有应用
    async noLoginApps({commit, state, dispatch}, filterApp) {
        await axios.get(`${window.commonApi.PATH}/api/noLogin/appList`).then(res => {
            if (res.data.code == 200) {
                var str = /^[A-Za-z]*$/;
                let appList = res.data.data.entities.map(item => {
                    return {
                        ...item,
                        shouzimu: str.test(pyChar.getFullChars(item.name).toUpperCase().slice(0, 1)) ? pyChar.getFullChars(item.name).toUpperCase().slice(0, 1) : pyChar.getFullChars(item.name).toUpperCase().slice(1, 1)
                    }
                });
                if (filterApp) {
                    state.appList = filterApp(appList);
                } else {
                    state.appList = appList;
                }
                dispatch('statsAppList', appList);
                commit('updateAppList');
                commit('updateAppAll');
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 登录状态查询办理次数
    getStatus({state, commit}, items) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/stats/apps`).then(res => {
            if (res.data.errno == 0) {
                state.statsRes = res.data.entities;
                commit('statsAppDates', items)
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 登录状态查询本周办理次数
    getTimeBetweenStatus({state, commit}, items) {
        const now = new Date();
        const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1);
        monday.setHours(0, 0, 0, 0); // 设置为0点
        const sunday = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 - now.getDay()));
        sunday.setHours(23, 59, 59, 999); // 设置为23点59分999毫秒
        axios.get(`${window.commonApi.INFOPLUS_URL}/stats/apps?start=${Math.floor(monday.getTime()/1000)}&finish=${Math.floor(sunday.getTime()/1000)}`).then(res => {
            if (res.data.errno == 0) {
                state.statsTimeBetweenRes = res.data.entities;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 未登录状态查询办理次数
    statsAppList({state, dispatch}, items) {
        let statArray = items;
        axios.get(`${window.commonApi.PATH}/api/noLogin/statsAppList`).then(res => {
            if (res.data.code == 200) {
                state.statsRes = res.data.data.entities;

                commit('statsAppDates', items)
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 查询收藏事项
    favoriteGet({commit}) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/preference/FavoriteApps`).then(res => {
            if (res.data.errno == 0) {
                let id = res.data.entities[0].id
                let favorites = res.data.entities[0].FavoriteApps
                state.userId = id;
                state.favorites = favorites
                commit('favoriteReset', favorites);
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 累计服务人数
    accumulateLength({state, dispatch, commit}) {
        axios.get(`${location.origin}${window.commonApi.PATH}/api/process/count/applier`).then(res => {
            if (res.data.code == 0) {
                state.accumulate = res.data.data;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 查询访问次数 (刷新页面记录一次)
    findViewsLength({state}, {startDate, endDate}) {
        axios.get(`${window.commonApi.TASKCENTER_API_URL}/api/app/views?labelName=loginOnce&start=${startDate}&end=${endDate}`).then(res => {
            if (res.data.code == 200) {
                if (startDate) {
                    state.todayViews = res.data.data;
                } else {
                    state.allViews = res.data.data;
                }
            }
        }).catch(error => {
            console.log(error);
        });
    },
    metodoLength({dispatch, commit}) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/tasks/todo?limit=1&start=0`).then(res => {
            if (res.data.errno == 0) {
                state.dataLength.todo = res.data.total;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    ccsLength({dispatch, commit}) {
        let params = {
            limit: 1,
            start: 0,
            unread: true,
        }
        axios.get(`${window.commonApi.INFOPLUS_URL}/me/processes/cc`, {params}).then(res => {
            if (res.data.errno == 0) {
                state.dataLength.cc = res.data.total;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    medoingsLength({dispatch, commit}) {
        let params = {
            limit: 1,
            start: 0,
        }
        axios.get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap['doing'].url}`, {params}).then(res => {
            if (res.data.errno == 0) {
                state.dataLength.doing = res.data.total;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    medonesLength({dispatch, commit}) {
        let params = {
            limit: 1,
            start: 0,
        }
        axios.get(`${window.commonApi.INFOPLUS_URL}/${state.apiMap['done'].url}`, {params}).then(res => {
            if (res.data.errno == 0) {
                state.dataLength.done = res.data.total;
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 获取委托事项
    async wtTodo({commit}, {owner}) {
        let wt_owner = owner ? 'entrustees' : 'entrusters';
        let id = state.userInfos.id;
        commit('loadingData', true);
        await axios.get(`${window.commonApi.INFOPLUS_URL}/user/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT/${wt_owner}`).then(res => {
            if (res.data.errno == 0) {
                let items = res.data.entities
                commit('wtReset', {items, wt_owner});
                commit('loadingData', false);
            } else {
                commit('loadingData', false);
            }
        }).catch(error => {
            console.log(error);
            commit('loadingData', false);
        });
    },
    //删除委托
    delWt({commit}, {id}) {
        let user = state.userInfos.id;
        axios.delete(`${window.commonApi.INFOPLUS_URL}/user/${user}/entrustees/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`).then(res => {
            if (res.data.errno == 0) {
                commit(`Message','success#删除成功#${new Date()}`);
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 抄送未读变已读
    async flow_read({dispatch, state, commit}, {ids, unread}) {
        let ccs = ids.split(",");
        for (let i in ccs) {
            await axios.post(`${window.commonApi.INFOPLUS_URL}/process/${ccs[i]}`, qs.stringify({"action": "read"})).then(res => {
                if (res.data.errno == 0) {
                    commit('Message', `success#已标记为已读#${new Date()}`);
                    dispatch('resetData', {dataName: 'flow_cc'});
                }
            }).catch(error => {
                console.log(error)
            })
        }
    },
    // 评分
    Rated({state, dispatch, commit}, {id, rating, review}) {
        axios.post(`${window.commonApi.INFOPLUS_URL}/process/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`, qs.stringify({
            "action": "rate",
            "rating": rating,
            "remark": review
        })).then(res => {
            if (res.data.errno == 0) {
                commit('Message', `success#评分成功#${new Date()}`);
                dispatch('resetData', {
                    dataName: 'done'
                });
            }
        }).catch(error => {
            console.log(error);

        })
    },
    // 需要批量办理时候的多选框
    process_push({commit, state}, {id, isok, clear}) {
        if (isok) {
            state.process_pass.push(id)
        } else {
            let arr = state.process_pass.join(',').replace(`com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`, '').split(',').filter((item) => {
                return item
            })
            state.process_pass = arr
        }

        if (clear) {
            state.process_pass = []
        }
        state.process_pass = Array.from(new Set(state.process_pass))
    },
    // 批量办理
    process_many({dispatch, state}, actionId) {
        state.process_pass.map((id) => {
            axios.post(`${window.commonApi.INFOPLUS_URL}/task/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`, qs.stringify({"actionId": actionId})).then(res => {
                if (res.data.errno == 0) {
                    dispatch('resetData', {dataName: 'todo'});
                }
            }).catch(error => {
                console.log(error);
            })
        })
    },
    // 单独一个快捷办理
    process_one({dispatch, state}, {actionId, id}) {
        axios.post(`${window.commonApi.INFOPLUS_URL}/task/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`, qs.stringify({"actionId": actionId})).then(res => {
            if (res.data.errno == 0) {
                dispatch('resetData', {dataName: 'todo'});
            }
        }).catch(error => {
            console.log(error);
        });
    },
    // 获取流程细节
    processTask({commit, state}, id) {
        axios.get(`${window.commonApi.INFOPLUS_URL}/process/com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`).then(res => {
            if (res.data.errno == 0) {
                let items = res.data.entities[0]
                return items
            }
        }).catch(error => {
            console.log(error);
        })
    },
    // 本地存储置顶，逻辑
    highChange({commit, state}) {
        let user = state.oidcStore.user.email;
        let highlights = localStorage.getItem(`${user}_top`).split(',').filter(item => item)
        commit('HighLightReset', highlights);
    },
    // 获取岗位信息
    getPositionsMes({commit, state}, id) {
        axios.get(`${window.commonApi.PATH}/api/user/positions?id=com.qtgl:taskcenter:war:0.0.1-SNAPSHOT`).then(res => {
            if (res.data.errno == 0) {
                state.positionsMes = res.data.entities
            }
        }).catch(error => {
            console.log(error);
        })
    },
    // 将参数原始化（操作 apiMap 对象）
    ClearQ({commit, state, dispatch}, {dataName}) {
        let origin_query = {
            limit: 10,
            start: 0,
            unread: true,
            keyword: '',
            lastUpdate: null,
            sep: null
        };
        let origin = state.apiMap[dataName];
        if (origin && origin.query) {
            for (let key in origin_query) {
                if (origin.query.hasOwnProperty(key)) {
                    origin.query[key] = origin_query[key];
                }
            }
            state.apiMap[dataName].query = origin.query;
        }
        dispatch('resetData', {dataName, 'query': origin.query});
    },
    // 添加后来的参数，如timestamp（操作 apiMap 对象）
    AddQ({state, dispatch}, {dataName, property, val}) {
        if (!state.apiMap[dataName].query.hasOwnProperty(property)) {
            state.apiMap[dataName].query[property] = val;
            dispatch('resetData', {dataName, query: state.apiMap[dataName].query});
        } else {
            dispatch('SearchQ', {key: dataName, property, val});
        }
    },
    // 获取待办，进行中，已完成，抄送等
    async resetData({commit, state, dispatch}, {dataName, query}) {
        // alert(333)
        commit('loadingData', true);
        let url = state.apiMap[dataName].url;
        let params = Object.assign({}, query || state.apiMap[dataName].query);

        if (params.hasOwnProperty('unread') && !params.unread) {
            delete params.unread;
        }
        if (params.hasOwnProperty('keyword') && !params.keyword) {
            delete params.keyword;
        }
        if (params.hasOwnProperty('timestamps') && !params.timestamps) {
            delete params.timestamps;
        }
        if (params.hasOwnProperty('lastUpdate') && !params.lastUpdate) {
            delete params.lastUpdate;
        }
        await axios.get(`${window.commonApi.INFOPLUS_URL}/${url}`, {params}).then(res => {
            if (res.data.errno == 0) {
                let items = res.data.entities;
                let total = res.data.total;
                commit('dataGet', {items, total, dataName});
                switch (dataName) {
                    case 'todo':
                        dispatch('highChange');
                        break;
                    case 'flow_cc':
                        dispatch('ccsLength');
                        break;
                }
            }
            commit('loadingData', false);
        }).catch(error => {
            console.log(error);
            commit('loadingData', false);
        });
    },
    // 调用接口的搜索
    SearchQ({dispatch, commit}, {key, property, val, limitRefresh}) { // limitRefresh限制刷新
        let str1 = JSON.stringify(state.apiMap[key].query);
        state.apiMap[key].query[property] = val;
        let str2 = JSON.stringify(state.apiMap[key].query);
        if (property != 'start' && property != 'limit') {
            state.apiMap[key].query['start'] = 0;
        }
        let query = state.apiMap[key].query;
        let dataName = key;
        commit('ChangeQ', {dataName, query}); //更改参数
        if (str1 != str2 && !limitRefresh) {
            dispatch('resetData', {dataName, query});
        }
    },
    // 首页和全部事项的搜索，筛选
    updateQuery({commit, state}, {seq, tag, dep, other, spe, zimu, secTag}) {
        // 如果不需要联动筛选
        // state.appQuery = {seq: '', tag: '', dep: '', other: '', spe:'', zimu: '',secTag: ''};
        state.appQuery.seq = seq || state.appQuery.seq;
        state.appQuery.tag = tag || state.appQuery.tag;
        state.appQuery.department = dep || state.appQuery.department;
        state.appQuery.other = other || state.appQuery.other;
        state.appQuery.spe = spe || state.appQuery.spe;
        state.appQuery.zimu = zimu || state.appQuery.zimu;
        state.appQuery.secTag = secTag || state.appQuery.secTag;
        if (seq === 'all') {
            state.appQuery.seq = '';
        }
        if (tag === 'all') {
            state.appQuery.tag = '';
        }
        if (dep === 'all') {
            state.appQuery.department = '';
        }
        if (other === 'all') {
            state.appQuery.other = '';
        }
        if (spe === 'all') {
            state.appQuery.spe = '';
        }
        if (zimu === 'all') {
            state.appQuery.zimu = '';
        }
        if (secTag === 'all') {
            state.appQuery.secTag = '';
        }
        commit('updateAppAll');
    }
}
const mutations = {
    updateAppList(state) {
        let appList = state.appList, recommends = [], tags = [], department = [], otherTags = [], specialTags = [],
            seconedTags = [];
        if (appList.length > 0) {
            for (let i in appList) {
                let obj = appList[i];
                if (obj.tags) {
                    let curSplitArr = obj.tags.split(',');
                    curSplitArr.forEach(item => {
                        if (item.indexOf('$dep$') > -1) {
                            let midDep = item.replace('$dep$', '').split('#');
                            department.push(...midDep);
                        }
                        if (item.indexOf('$tag$') > -1) {
                            let midTag = item.replace('$tag$', '').split('#');
                            tags.push(...midTag);
                        }
                        if (item.indexOf('$other$') > -1) {
                            let midOther = item.replace('$other$', '').split('#');
                            otherTags.push(...midOther);
                        }
                        if (item.indexOf('$spe$') > -1) {
                            let midOther = item.replace('$spe$', '').split('#');
                            specialTags.push(...midOther);
                        }
                        // 二级分类（分类中带有一级分类，渲染时去除）
                        if (item.indexOf('$second-tag$') > -1) {
                            let midSeconedTags = item.replace('$second-tag$', '');
                            seconedTags.push(midSeconedTags);
                        }
                    })
                }
            }
            tags = Array.from(new Set(tags)).sort();
            department = Array.from(new Set(department)).sort();
            otherTags = Array.from(new Set(otherTags)).sort();
            seconedTags = Array.from(new Set(seconedTags)).sort();
            specialTags=Array.from(new Set(specialTags)).sort();
            recommends = appList.filter(item => item.recommend && item.recommend > 0);
        }
        state.tags = tags;
        state.department = department;
        state.otherTags = otherTags;
        state.seconedTags = seconedTags;
        state.specialTags = specialTags;
        state.recommends = recommends.sort((a, b) => a.recommend - b.recommend);
    },
    updateAppAll(state, appList) {
        function curRules(type, tag) { // 获取具体要匹配过滤的项
            let curTag = '' // 当前类型对应的值
            if (tag.indexOf(type) > -1) {
                let midTag = tag.split(',');
                midTag.forEach(item => {
                    if (item.indexOf(type) > -1) {
                        curTag = item;
                    }
                })
            }
            return curTag;
        }

        if (appList) {
            state.appList = appList;
        }
        let allApps = state.appList, filteredApps = [], filteredAppsList = [];
        for (let key in allApps) {
            let objNow = allApps[key];
            let limit = [false, false, false, false, false, false];
            if (state.appQuery.seq && (objNow.name.indexOf(state.appQuery.seq) == -1) && curRules('$dep$', objNow.tags).indexOf(state.appQuery.seq) == -1 && curRules('$tag$', objNow.tags).indexOf(state.appQuery.seq) == -1) {
                limit[0] = true;
            }
            if (state.appQuery.department && curRules('$dep$', objNow.tags).indexOf(state.appQuery.department) == -1) {
                limit[1] = true;
            }
            if (state.appQuery.tag && curRules('$tag$', objNow.tags).indexOf(state.appQuery.tag) == -1) {
                limit[2] = true;
            }
            if (state.appQuery.other && curRules('$other$', objNow.tags).indexOf(state.appQuery.other) == -1) {
                limit[3] = true;
            }
            if (state.appQuery.spe && curRules('$spe$', objNow.tags).indexOf(state.appQuery.spe) == -1) {
                limit[4] = true;
            }
            if (state.appQuery.secTag && curRules('$second-tag$', objNow.tags).indexOf(state.appQuery.secTag) == -1) {
                limit[5] = true;
            }
            if (limit.indexOf(true) == -1) {
                filteredApps.push(objNow);
            }
        }
        state.zimu = Array.from(new Set(filteredApps.map(item => item.shouzimu))).sort();  // 首字母排序
        // 有字母筛选字母下的app，默认返回其他筛选条件的
        state.tagApps = state.appQuery.zimu ? filteredApps.filter(item => item.shouzimu == state.appQuery.zimu) : filteredApps;
        state.loadingDataStart = false;
    },
    // 过滤收藏app
    favoriteReset(state, favorites) {
        state.favorites = favorites;
        state.favoriteApps = state.favorites.map(item1 => state.appList.filter(item2 => item2.id == item1)[0]).filter(exit => exit);
    },
    // processCounters：办理次数总和
    statsAppDates(state, items) {
        state.appList = items.map(item1 => {
            let item2 =  state.statsRes.filter(item => item.id == item1.id), counts = 0;
            counts = item2[0] && item2[0].processCounters && item2[0].processCounters.completed + item2[0].processCounters.running + item2[0].processCounters.suspended + item2[0].processCounters.killed;
            item1.processCounters = counts;
            return item1;
        })
    },
    wtReset(state, {items, wt_owner}) {
        state.wtThings[wt_owner] = items;
    },
    // 置顶
    HighLightReset(state, highlights) {
        state.highlights = highlights.filter(item => item);
    },
    dataGet(state, {items, total, dataName}) {
        state.dataSource[dataName] = items;
        state.dataLength[dataName] = total;
    },
    ChangeQ(state, {dataName, query}) {
        state.apiMap[dataName].query = Object.assign({}, query);
    },
    // 骨架屏
    loadingData(state, load_bool) {
        state.loadingDataStart = load_bool;
    },
    // 传递消息
    Message(state, word) {
        state.targetMessage = word;
    },
    // 长链接
    toIsCanFresh(state, bool) {
        state.isCanFresh = bool;
    },
    // profile问题
    setUserInfo(state, obj) {
        state.userInfos = Object.assign({}, obj);
    },
    //
    setvalue(state, obj) {
        state.searchValue = obj
    },
}

const modules = {
    oidcStore: vuexOidcCreateStoreModule(
        oidcSettings,
        {
            namespaced: true,
            dispatchEventsOnWindow: true
        },
        {
            userLoaded: (user) => console.log('OIDC user is loaded:', user),
            userUnloaded: () => console.log('OIDC user is unloaded'),
            accessTokenExpiring: () => console.log('Access token will expire'),
            accessTokenExpired: () => console.log('Access token did expire'),
            silentRenewError: () => console.log('OIDC user is unloaded'),
            userSignedOut: () => console.log('OIDC user is signed out'),
            oidcError: (payload) => console.log('OIDC error', payload)
        }
    )
}

export default {
    modules,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js